var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 2,
    viewBox: "0 0 10 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.262573C0.723858 0.262573 0.5 0.486431 0.5 0.762573C0.5 1.03872 0.723858 1.26257 1 1.26257V0.262573ZM9 1.26257C9.27614 1.26257 9.5 1.03872 9.5 0.762573C9.5 0.486431 9.27614 0.262573 9 0.262573V1.26257ZM1 1.26257H9V0.262573H1V1.26257Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubtract);
export default __webpack_public_path__ + "static/media/iconSubtract.05556fc9049ee8a8769da6471fa79aff.svg";
export { ForwardRef as ReactComponent };